export default "__VITE_ASSET__DECS1pFa__"